import { inject, injectable } from 'inversify-props';
import { IHttpClient, ILogger, ISettings } from '../common';
import { PagedResult, DeckPrice } from '../../models';


export interface IDeckPriceService  {
	get(deckId: string, id: string): Promise<DeckPrice>;
	page(deckId: string, pageIndex: number, pageSize: number): Promise<PagedResult<DeckPrice>>;
	list(deckId: string): Promise<DeckPrice[]>;
	save(model: DeckPrice): Promise<DeckPrice>;
	delete(deckId: string, priceId: string): Promise<any>;
}


@injectable()
export class DeckPriceService implements IDeckPriceService {

	constructor(
		@inject('IHttpClient') private httpClient: IHttpClient,
		@inject('ILogger') private logger: ILogger,
		@inject('ISettings') private settings: ISettings) { }

	public get(deckId: string, id: string): Promise<DeckPrice> {
		const url = `${this.settings.baseUrl}${this.settings.deckBaseUrl}/${deckId}/prices/${id}`;
		return this.httpClient.get<DeckPrice>(url);
	}

	public page(deckId: string, pageIndex: number, pageSize: number): Promise<PagedResult<DeckPrice>> {
		const url = `${this.settings.baseUrl}${this.settings.deckBaseUrl}/${deckId}/prices/${pageIndex}/${pageSize}`;
		return this.httpClient.get<PagedResult<DeckPrice>>(url);
	}

	public list(deckId: string): Promise<DeckPrice[]> {
		const url = `${this.settings.baseUrl}${this.settings.deckBaseUrl}/${deckId}/prices/`;
		return this.httpClient.get<DeckPrice[]>(url);
	}

	public save(model: DeckPrice): Promise<DeckPrice> {
		const payload = {
			id: model.id,
			deckId: model.deckId,
			conditionId: model.conditionId,
			amount: parseFloat(model.amount.toString()),
			link: model.link,
			isVerified: model.isVerified,
			isEnabled: model.isEnabled,
			notes: model.notes,
			postingDate: model.postingDate,
		};

		let url = `${this.settings.baseUrl}${this.settings.deckBaseUrl}/${model.deckId}/prices`;
		if (model.id !== null && model.id !== undefined && model.id) {
			url += `/${model.id}`;
			return this.httpClient.put<DeckPrice>(url, payload);
		}

		return this.httpClient.post<DeckPrice>(url, payload);
	}

	public delete(deckId: string, priceId: string): Promise<any> {
		const url = `${this.settings.baseUrl}${this.settings.deckBaseUrl}/${deckId}/prices/${priceId}`;
		return this.httpClient.delete(url);
	}

}
